import React from 'react';
import styled from 'styled-components';
import Result from './result';

const Asesmen = styled.div`
    text-align: center;
    height: 100%;
    margin: -10px -30px;
`
const variableMap = {
    "CAMPAIGN-VARIABLE-s6l~~GmtXzCtmyB~AOoR8": {
        dimension: 'd',
        type: 'most'
    },
    "CAMPAIGN-VARIABLE-RKMggtg~7Idfv3_Eicpq6": {
        dimension: 'd',
        type: 'least'
    },
    "CAMPAIGN-VARIABLE-nrZqgHzUEKzB7cT08VCDQ": {
        dimension: 'i',
        type: 'most'
    },
    "CAMPAIGN-VARIABLE-VyIvYMU3taiI3fIq7bJmF": {
        dimension: 'i',
        type: 'least'
    },
    "CAMPAIGN-VARIABLE-2ZwTTCceaAfivfn8pHHeV": {
        dimension: 's',
        type: 'most'
    },
    "CAMPAIGN-VARIABLE-LxNMNksiXQ4BuUb7IKkUS": {
        dimension: 's',
        type: 'least'
    },
    "CAMPAIGN-VARIABLE-KkrWtgeYNEkGeOVfjvNi0": {
        dimension: 'c',
        type: 'most'
    },
    "CAMPAIGN-VARIABLE-P~vqGqQV5h~E4ElpegCbW": {
        dimension: 'c',
        type: 'least'
    }
}
const convertVariable = (variables) => {
    const result = {}
    for (const { guid, value } of variables) {
        const variable = variableMap[guid]
        if (!variable) throw Error('Cannot find variable')
        const { dimension, type } = variable
        if (!result[dimension]) result[dimension] = {}
        result[dimension][type] = value
    }
    return result
}
export default function () {
    const [iframeLoadLoading, setIframeLoadLoading] = React.useState(true)
    const [result, setResult] = React.useState()
    const onMessageListener = React.useCallback((message) => {
        setResult(convertVariable(message.data.variables || []))
    }, [])
    React.useEffect(() => {
        window.addEventListener('message', onMessageListener);
        return () => window.removeEventListener("message", onMessageListener);
    });
    if (result) return <Result result={result} />
    return (
        <Asesmen>
            {iframeLoadLoading && <h4>Loading...</h4>}
            <iframe onLoad={() => setIframeLoadLoading(false)} frameBorder="0" allowfullscreen
                style={{ display: iframeLoadLoading ? 'none' : 'unset', width: '100%', height: '100%' }} src={process.env.REACT_APP_ASSESSMENT_URL} />
        </Asesmen>)
}